import React from "react";
import { Badge, Input, Select } from "../../../design-system";

export function DocumentsFilterBar({
  search,
  onSearchChange,
  employeeFilter,
  employeeFilterName,
  onClearEmployeeFilter,
  categoryFilter,
  onCategoryFilterChange,
  categories,
  expiryFilter,
  onExpiryFilterChange,
  resultsCount,
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 16px",
        borderBottom: "1px solid var(--kr-border-subtle)",
        flexWrap: "wrap",
      }}
    >
      <Input
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Buscar por título, archivo o empleado…"
        icon="Search"
        style={{ flex: 1, maxWidth: 360 }}
      />
      {employeeFilter && (
        <Badge tone="brand" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          Empleado: {employeeFilterName || "(sin nombre)"}
          <button
            type="button"
            onClick={onClearEmployeeFilter}
            aria-label="Quitar filtro de empleado"
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              padding: 0,
              marginLeft: 2,
              color: "inherit",
              fontSize: 14,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </Badge>
      )}
      <span
        style={{
          fontSize: 11,
          color: "var(--kr-fg-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 600,
          marginLeft: 8,
        }}
      >
        Categoría
      </span>
      <Select
        value={categoryFilter}
        onChange={(e) => onCategoryFilterChange(e.target.value)}
        style={{ minWidth: 200 }}
      >
        <option value="all">Todas</option>
        {(categories || []).map((root) => (
          <React.Fragment key={root.id}>
            <option value={root.id}>{root.name}</option>
            {(root.children || []).map((child) => (
              <option key={child.id} value={child.id}>
                {`    › ${child.name}`}
              </option>
            ))}
          </React.Fragment>
        ))}
      </Select>
      <span
        style={{
          fontSize: 11,
          color: "var(--kr-fg-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 600,
          marginLeft: 8,
        }}
      >
        Caducidad
      </span>
      <Select
        value={expiryFilter}
        onChange={(e) => onExpiryFilterChange(e.target.value)}
        style={{ minWidth: 160 }}
      >
        <option value="all">Todos</option>
        <option value="valid">Vigentes</option>
        <option value="soon">Próximos a vencer</option>
        <option value="expired">Vencidos</option>
      </Select>
      <div style={{ flex: 1 }} />
      <span
        style={{
          fontSize: 11,
          color: "var(--kr-fg-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 600,
        }}
      >
        {resultsCount} documento{resultsCount === 1 ? "" : "s"}
      </span>
    </div>
  );
}
